/**
 * Plain-language summary of what a realism level changes, built from the realism table so the
 * setup screen never disagrees with the sim.
 */
import type { RealismOptions } from '@atc/core';

export function describeRealism(o: RealismOptions): string[] {
  const [dMin, dMax] = o.complianceDelayS;
  const lines = [
    dMax === 0 ? 'Pilots act as soon as they read back' : `Pilots act ${dMin}–${dMax} s after the readback`,
    o.wrongReadbackRate > 0 ? `About ${Math.round(o.wrongReadbackRate * 100)} in 100 readbacks come back wrong` : '',
    o.wind === 'none' ? 'No wind' : o.wind === 'steady' ? 'Steady wind' : 'Gusting, shifting wind',
    !o.arrivalsFollowStar ? 'Arrivals come straight in from the scope edge' : o.descendVia ? 'Arrivals fly their STAR and descend on its limits' : 'Arrivals fly their STAR',
    o.unstableApproachGoAround ? (o.runwayOccupancyCheck ? 'Go-arounds for unstable approaches and occupied runways' : 'Unstable approaches go around') : '',
    o.wakeSeparation ? 'Wake turbulence spacing counts' : '',
    o.radarSweepS > 0 ? `Radar updates every ${o.radarSweepS} s` : '',
    o.runwayDrawScale > 1 ? `Runways drawn ×${o.runwayDrawScale} for readability` : 'Runways drawn to scale',
  ];
  return lines.filter((l) => l !== '');
}
